/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.21.0
 */

import type { IAccountDeliveryAddressInfo } from './types/pageAccountInfoGeneralTypes';
import type { IAccountInfoDeliveryData } from './types/pageAccountInfoTypes';

export type TClientId = string & { readonly brand: unique symbol };

export function ClientId(id: string) {
    return id as TClientId;
}

export interface IAccountInfoQuery {
    clientId: string;
}

export interface IMultiBalanceEventsQuery extends IAccountInfoQuery {
    expandedBalanceId: number;
}

export type IAccountInfoRequestDeliveryData = Partial<
    Omit<IAccountInfoDeliveryData, 'email' | 'address'> & {
        email: string | null;
    } & {
        address: Partial<IAccountDeliveryAddressInfo>;
    }
>;

export type IAccountInfoRequestDeliveryDataInquiry = Partial<
    Omit<IAccountInfoDeliveryData, 'email' | 'address'> & {
        email: string | null;
    } & {
        address: Partial<IAccountDeliveryAddressInfo>;
    } & {
        isEmailDeliveryChanged: boolean;
        isEmailChanged : boolean;
    }
>;

export type TDeliveryUpdateRequest = {
    clientId: TClientId;
    deliveryData: IAccountInfoRequestDeliveryData;
};

export type TDeliveryUpdateInquiryRequest = {
    clientId: TClientId;
    deliveryData: IAccountInfoRequestDeliveryDataInquiry;
};

export type TEdmDeliveryViewedRequest = {
    clientId: string;
};
